import styles from "./parameterForms.module.css";

/**
 * A parameter's validation message, for a control that has no `Field.Error`
 * of its own. Renders nothing while the value is valid.
 */
export function ParameterError({ message }: { message: string | undefined }) {
  if (message === undefined) {
    return null;
  }
  return <p className={styles.error}>{message}</p>;
}
